export default `query route($url: String! ) {
    route(url: $url) {
      __typename
      type
      ... on SimpleProduct {
        sku
        name
        meta_title
        meta_keyword
        meta_description
      }
      ... on ConfigurableProduct {
          sku
          name
          meta_title
          meta_keyword
          meta_description
      }
      ... on DownloadableProduct {
          sku
          name
          meta_title
          meta_keyword
          meta_description
      }
      ... on VirtualProduct {
          sku
          name
          meta_title
          meta_keyword
          meta_description
      }
      ... on GroupedProduct {
          sku
          name
          meta_title
          meta_keyword
          meta_description
      }
      ... on BundleProduct {
          sku
          name
          meta_title
          meta_keyword
          meta_description
      }
      ... on CategoryTree {
        uid
        name
        meta_title
        meta_description
        meta_keywords
      }
      ... on CmsPage {
        identifier
        title
        meta_title
        meta_description
        meta_keywords
      }
    }
  }`